import "./Yearly.css"
import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import APIURL from "../../common/Config";
import Header from "../header/header";
import Footer from "../footer/footer";

const Geminiyearly = () => {
  const [horoscopeData, setHoroscopeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const inMemoryCacheRef = useRef(new Map());
  const [activeIndex, setActiveIndex] = useState(null);

  // Static metadata for GEMINI
  const staticMeta = {
    title: "AstroBhagya – Free Gemini Yearly Horoscope by Best Astrologer",
    description: "Looking for accurate Gemini yearly horoscope predictions 2026? Discover free Gemini astrology predictions and annual insights by zodiac sign for a better year ahead.",
    keywords: "Free Gemini yearly horoscope predictions 2026, Gemini yearly Astrology predictions, Gemini annual predictions, Yearly horoscope by Gemini zodiac sign",
    author: "Heavenly Expectation Private Limited",
  };

  const toggleAnswer = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const fetchGeminiYearly = useCallback(async (retries = 3) => {
    const dateStr = "20260101"; // 2026 data
    const cacheKey = `gemini_yearly_${dateStr}`; 
    setError(null);
    setLoading(true);

    // 1. CHECK LOCALSTORAGE
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      try {
        const parsed = JSON.parse(cachedData);
        setHoroscopeData(parsed);
        setLoading(false);
        return;
      } catch (e) {
        console.error("Failed to parse cached data:", e);
      }
    }

    // 2. CHECK IN-MEMORY CACHE
    if (inMemoryCacheRef.current.has(cacheKey)) {
      setHoroscopeData(inMemoryCacheRef.current.get(cacheKey));
      setLoading(false);
      return;
    }

    const minLoadingTime = new Promise(resolve => setTimeout(resolve, 500));

    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        console.warn('Fetch request timed out after 15 seconds.');
      }, 15000);

      const response = await fetch(
        `${APIURL}/horroscope/getallprediction?type=yearly&startDate=${dateStr}&endDate=${dateStr}&language=english`,
        { signal: controller.signal }
      );

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (Array.isArray(data)) {
        // Find GEMINI data (id: 31 or sunShine contains "GEMINI") 🔥 ID=31
        const geminiData = data.find(
          item => item.id === 32 || item.sunShine?.toUpperCase().includes("GEMINI")
        );

        if (geminiData) {
          // Cache the data
          inMemoryCacheRef.current.set(cacheKey, geminiData);
          localStorage.setItem(cacheKey, JSON.stringify(geminiData));
          setHoroscopeData(geminiData);
        } else {
          throw new Error("Gemini data not found in API response");
        }
      } else {
        throw new Error("Unexpected response format from API");
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        setError('The network request timed out. Please check your internet connection and try again.');
        console.error("Network timeout error:", error);
      } else {
        setError(`Failed to load yearly horoscope: ${error.message}. Please try again.`);
        console.error("Error fetching Gemini yearly data:", error);
      }

      if (retries > 0) {
        console.log(`Retrying fetch for Gemini Yearly. Retries left: ${retries - 1}`);
        await new Promise(resolve => setTimeout(resolve, 3000));
        return fetchGeminiYearly(retries - 1);
      } else {
        // FALLBACK DATA - GEMINI 2026 
        console.log("All retries exhausted. Using fallback data.");
        const fallbackData = {
          sunShine: "Gemini 2026: Your year, as the stars align",
          prediction: `<div class="horoscope">
            <p>As 2026 unfolds, Gemini, the year asks you to slow down and become more intentional with your thoughts, plans, and actions. Unlike years that push you toward constant movement, 2026 highlights clarity, structure, and follow-through.</p>
            <h2>Love and Relationships</h2>
            <p>Relationshipssssssssssssss in 2026 ask Gemini for emotional presence and consistency. Important conversations about emotional needs and long-term plans will bring clarity.</p>
            <h2>Career and Finances</h2>
            <p>Career matters take a serious turn in 2026. Increased responsibility and skill development will build professional credibility. Budgeting essential for education/travel expenses.</p>
            <h2>Health & Wellness</h2>
            <p>Health requires mental/physical balance. Mental fatigue from overthinking possible. Breathing exercises and digital detox improve clarity.</p>
            <h2>Astrological Remedies</h2>
            <ul>
              <li><strong>Wear Green Jade or Emerald:</strong> Supports mental clarity and decision-making.</li>
              <li><strong>Wednesday Discipline:</strong> Cleanliness and green offerings strengthen Mercury.</li>
              <li><strong>Learning Charity:</strong> Donating books enhances intellectual clarity.</li>
            </ul>
          </div>`
        };
        setHoroscopeData(fallbackData);
      }
    } finally {
      await minLoadingTime;
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGeminiYearly();
  }, [fetchGeminiYearly]);

  // Set meta tags
  useEffect(() => {
    document.title = staticMeta.title;

    const setOrCreateMetaTag = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (metaTag) {
        metaTag.setAttribute("content", content);
      } else {
        metaTag = document.createElement("meta");
        metaTag.setAttribute("name", name);
        metaTag.setAttribute("content", content);
        document.head.appendChild(metaTag);
      }
    };

    setOrCreateMetaTag("description", staticMeta.description);
    setOrCreateMetaTag("keywords", staticMeta.keywords);
    setOrCreateMetaTag("author", staticMeta.author);
    setOrCreateMetaTag("revisit-after", "7 days");
    setOrCreateMetaTag("distribution", "global");
    setOrCreateMetaTag("rating", "general");

    let charsetMeta = document.querySelector("meta[charset]");
    if (!charsetMeta) {
      charsetMeta = document.createElement("meta");
      charsetMeta.setAttribute("charset", "UTF-8");
      document.head.prepend(charsetMeta);
    }
  }, []);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner" />
        <p>Loading Gemini 2026 Horoscope...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>{error}</p>
        <button className="retry-button" onClick={() => fetchGeminiYearly()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div>
        <section id="Make">
          <div className="year-container">
            <h4 className="mt-3 mb-3 text-center font-weight-bold">
              {horoscopeData?.sunShine || "Gemini 2026: Your year, as the stars align"}
            </h4>
            <div className="icons-wrapper text-center mb-4">
              <img
                src={require("../../assets/Geminiii.webp")}
                alt="Gemini"
                className="horoscope-icon mx-2"
              />
            </div>

            {horoscopeData?.prediction && (
              <main>
                <div
                  dangerouslySetInnerHTML={{
                    __html: horoscopeData.prediction
                  }}
                />
              </main>
            )}

            <div className="btn-wrapper">
              <Link to="/yearly-horoscope/taurus" className="btn btn-customs">
                <i className="bi bi-arrow-left"></i> Taurus Horoscope 2026
              </Link>
              <Link to="/yearly-horoscope/cancer" className="btn btn-customs">
                <i className="bi bi-arrow-right"></i> Cancer Horoscope 2026
              </Link>
            </div>
          </div>
        </section>

        {/* FAQ SECTION - SAME AS ARIES/TAURUS */}
        <div className="faq-section">
          <div className="container-item">
            <h3>Frequently Asked Questions (FAQs) – Gemini Yearly Horoscope</h3>
            <div className="fitem">
              {[
                {
                  question: "1. What are the core personality traits of Gemini?",
                  answer: "Gemini individuals are known for their adaptability, curiosity, and excellent communication skills. Ruled by Mercury, they thrive on intellectual stimulation and variety.",
                },
                {
                  question: "2. What can Gemini expect in love and relationships in 2026?",
                  answer: "In 2026, Gemini relationships require emotional presence. Important conversations about needs and long-term plans bring clarity and stability.",
                },
                {
                  question: "3. What does 2026 look like for Gemini career growth?",
                  answer: "Career demands focus and discipline. Skill development and strategic planning build credibility. Avoid distractions for long-term success.",
                },
                {
                  question: "4. What health advice for Gemini in 2026?",
                  answer: "Mental fatigue from overthinking possible. Breathing exercises, digital detox, and consistent routines improve mental clarity.",
                },
                {
                  question: "5. Key astrological remedies for Gemini?",
                  answer: "Wear Green Jade/Emerald, Wednesday rituals, and learning-based charity enhance Mercury's positive influence.",
                },
              ].map((item, index) => (
                <div className="faq-item" key={index}>
                  <div
                    className={`faq-question ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleAnswer(index)}
                  >
                    {item.question}
                  </div>
                  <div
                    className={`faq-answer ${
                      activeIndex === index ? "show" : ""
                    }`}
                  >
                    {item.answer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Geminiyearly; 
